import React from "react";
import "./index.scss";
import {strings} from "../../../../strings/strings";

interface Props {
    onNext: (event: any) => void;
    nextIsAvailable?: boolean;
    onBack?: () => void;
    leftSteps?: number;
    nextStepLabel?: string
}

export const StepControls = ({onNext, onBack, nextIsAvailable, leftSteps, nextStepLabel}: Props) => {
    const getText = () => {
        switch (leftSteps) {
            case 0:
                return strings.stepsZero;
            case 1:
                return strings.stepsOne;
            case 2:
                return strings.stepsTwo;
            case 3:
                return strings.stepsThree;
            case 4:
                return strings.stepsFour;
            case 5:
                return strings.stepsFive;
            case 6:
                return strings.stepsSix;
        }
    };

    return (
        <div className="step-controls">
            <div className="step-controls__container">
                <div className="step-controls__back">
                    <button className='step-controls__back__button'
                            type={"button"}
                            onClick={() => onBack()}>
                        {strings.stepsBack}
                    </button>
                </div>
                <div className="step-controls__right">
                    <div className="step-controls__text">
                        {getText()}
                    </div>
                    <div
                        className={`step-controls__next ${nextIsAvailable !== undefined && !nextIsAvailable ? 'step-controls__next_disabled' : ''}`}>
                        <button className={'step-controls__next__button'}
                                type={"button"}
                                disabled={!nextIsAvailable}
                                onClick={(event) => onNext(event)}>
                            {nextStepLabel || strings.stepsNext}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
};